
const utils = {}

utils.columns = [
    {
        title: '序号',
        width: 80,
        scopedSlots: { customRender: 'num' }
    },
    {
        title: "计划",
        dataIndex: "plan",
        scopedSlots: { customRender: "plan" },
    },
    {
        title: "姓名",
        dataIndex: "name",
    },
    {
        title: "证件类型",
        dataIndex: "idType",
        key: "idType",
        scopedSlots: { customRender: "idType" },
    },
    {
        title: "证件号码",
        dataIndex: "idNumber",
    },
    {
        title: "出生日期",
        dataIndex: "birthDate",
    },
    {
        title: "性别",
        dataIndex: "gender",
        key: "gender",
        scopedSlots: { customRender: "gender" },
    },
    {
        title: "职业名称",
        dataIndex: "occupationName",
    },
];
utils.IdTypeOptions = [
    {
        value: "1",
        name: "身份证",
    },
    {
        value: "2",
        name: "护照",
    },
    {
        value: "3",
        name: "台湾居民来往大陆通行证",
    },
    {
        value: "4",
        name: "港澳通行证",
    },
    {
        value: "5",
        name: "出生证",
    },
    {
        value: "9",
        name: "户口本",
    },
    {
        value: "99",
        name: "其他",
    },
]
utils.occupationOptionsLevel = [
    {
      value: '1',
      name: '1类'
    },
    {
      value: '2',
      name: '2类'
    },
    {
      value: '3',
      name: '3类'
    },
    {
      value: '4',
      name: '4类'
    }
], 
//处理证件类型
utils.getterIdtype = function (value) {
    switch (value) {
        case '身份证':
        case '01':
        case 1:
        case '1':
            return '身份证'
        case '护照':
        case '02':
        case '2':
        case 0:
            return '护照'
        case '其它':
        case '99':
        case 99:
            return '其它'
        case '06':
        case '6':
        case 6:
            return '港澳回乡证或台胞证'
        default:
            return '身份证'
    }
};
//过滤身份证信息的公共方法
utils.filterAllINTYPE = function (idType) {
    switch (idType) {
        case '身份证':
        case '01':
        case 1:
        case '1':
            return '01'
        case '护照':
        case '02':
        case '2':
        case 0:
            return '02'
        case '港澳回乡证或台胞证':
        case '06':
        case '6':
        case 6:
            return '06'
        case '其它':
        case '99':
        case 99:
            return '99'
        default:
            return '01'
    }
}

//处理性别
utils.getterGender = function (value) {
    switch (value) {
        case 'M':
        case '男':
            return '男'
        case 'F':
        case '女':
            return '女'
        default:
            return '男'
    }
}
//反转对象
utils.resoverObj = function (obj) {
    var a = {
        '1类': 0,
        '2类': 0,
        '3类': 0,
        '4类': 0,
        '5类': 0
    };
    for (const key in obj) {
        a[key] = obj[key];
    }
    return a;
}
//提交的去重
utils.unique = function (arr, attribute) {
    var new_arr = [];
    var json_arr = [];
    for (var i = 0; i < arr.length; i++) {
        if (new_arr.indexOf(arr[i][attribute]) == -1) {
            //  -1代表没有找到
            new_arr.push(arr[i][attribute]); //如果没有找到就把这个name放到arr里面，以便下次循环时用
            json_arr.push(arr[i]);
        }
    }
    return json_arr;
}

export default utils